import * as user from './system/user'
import * as role from './system/role'
import * as view from './system/view'
import * as menu from './system/menu'
import * as person from './system/person'
import * as features from './system/features'
import * as organization from './system/organization'
import * as place from './system/place'
import * as phoneCode from './system/phoneCode'
import * as tenancy from './system/tenancy'
import * as ioam from './ioam'
import * as feedback from './system/feedback'
import * as carousel from './system/carousel'
import * as application from './system/application'
import * as data from './system/data'
import * as stationScreen from './system/stationScreen'
import * as calibrationTips from './system/calibrationTips'
import * as device from './system/device'
import * as deviceActions from './system/deviceActions'

export default {
  // 手机验证码
  code_check: phoneCode.checkCode,
  code_add: phoneCode.addCode,
  code_send: phoneCode.sendCode,
  // 业务平台
  ioam_personList: ioam.personList,
  ioam_departmentList: ioam.departmentList,
  // 用户
  user_add: user.add,
  user_query: user.query,
  user_getUer: user.getUser,
  user_update: user.update,
  user_token: user.userToken,
  user_delete: user.deleteUser,
  user_login: user.login,
  user_tokenVerify: user.tokenVerify,
  user_logout: user.logout,
  user_forgetPasswd: user.forgetPasswd,
  user_userListByUserName: user.userListByUserName,
  user_userAll: user.userAll,
  user_updateIdtoken: user.updateIdtoken,
  user_getTokenSJ: user.getTokenSJ,
  user_getUserInfoSJ: user.getUserInfoSJ,
  user_loginByJaccount: user.loginByJaccount,
  user_logoutByJaccount: user.logoutByJaccount,
  user_getCsInfos: user.getCsInfos,
  // 角色
  role_query: role.query,
  role_template: role.template,
  role_getRole: role.getRole,
  role_add: role.add,
  role_update: role.update,
  role_delete: role.deleteRole,
  // 菜单
  menu_getMenuTree: menu.getMenuTree,
  menu_getAllMenuTree: menu.getAllMenuTree,
  menu_getMenuList: menu.getMenuList,
  menu_add: menu.add,
  menu_update: menu.update,
  menu_delete: menu.deleteMenu,
  menu_getMenuTemplateTree: menu.getMenuTemplateTree,
  // 员工
  person_isOwnPermission: person.isOwnPermission,
  person_faceCheck: person.faceCheck,
  person_personAll: person.personAll,
  person_query: person.query,
  person_update: person.update,
  person_add: person.add,
  person_getPerson: person.getPerson,
  person_getPersonByQuery: person.getPersonByQuery,
  person_delete: person.deletePerson,
  person_deleteBatch: person.deletePersonBatch,
  person_getName: person.findUserName,
  person_importPerson: person.importPerson,
  person_importPeople: person.importPeople,
  person_downloadFile: person.downloadFile,
  person_allowedImport: person.allowedImport,
  person_pollImportResult: person.pollImportResult,
  person_exportPeople: person.exportPeople,
  // person_globalTest: person.globalTest,
  // 组织结构树
  organization_loadTree: organization.load,
  organization_byId: organization.byId,
  organization_addTree: organization.add,
  organization_delete: organization.deleteTree,
  organization_update: organization.updateTree,
  // 场所结构树
  place_loadTree: place.load,
  place_byId: place.byId,
  place_delete: place.deleteTree,
  place_addTree: place.add,
  place_update: place.updateTree,
  place_tenantConfig: place.tenantConfig,
  place_move: place.moveTree,
  place_find: place.find,
  isExistUseSpace: place.isExistUseSpace,
  place_getAreaCode: place.getAreaCode,
  place_regionWidthFeature: place.findRegionWidthFeature,
  // 视图
  view_pageFind: view.pageFind,
  view_save: view.save,
  isBindRegion: view.isBindRegion,
  remove: view.remove,
  bindRegion: view.bindRegion,
  unBind: view.unBind,
  view_checkUpload: view.checkUpload,
  view_edit: view.edit,
  check_view_name: view.checkViewName,
  updateRegion: view.updateRegion,
  updateStatus: view.updateStatus,
  // 租户
  tenancy_query: tenancy.query,
  tenancy_byId: tenancy.byId,
  tenancy_addOne: tenancy.addOne,
  tenancy_updateOne: tenancy.updateOne,
  tenancy_deleteOne: tenancy.deleteOne,
  // featuees 元素
  features_batchSave: features.batchSave,
  features_batchEdit: features.batchEdit,
  features_findByRegionId: features.findByRegionId,
  features_publish: features.featurePublish,
  features_restore: features.featureRestore,
  features_getRefreshViewChangeMath: features.getRefreshViewChangeMath,
  features_getPublishInfo: features.getPublishInfo,
  features_getPublishFeaturesByRegion: features.getPublishFeaturesByRegion,
  features_getPublishFeaturesByRegions: features.getPublishFeaturesByRegions,
  features_getPublishFeatureById: features.getPublishFeatureById,
  // calibrationTips 标定消息提示配置
  calibrationTip_getOne: calibrationTips.getCalibrationTip,
  calibrationTip_setDisabledUser: calibrationTips.setDisabledUser,
  calibrationTip_validDisabledUser: calibrationTips.validDisabledUser,
  // 反馈
  feedback_query: feedback.query,
  feedback_get: feedback.get,
  // 轮播图
  carousel_query: carousel.query,
  carousel_get: carousel.get,
  carousel_edit: carousel.edit,
  // 应用设置
  application_query: application.query,
  application_update: application.update,
  // 埋点
  abnormalData_query: data.query,
  data_downloads: data.downloads,
  data_top10: data.top10,
  data_usersCount: data.usersCount,
  data_deviceStatistic: data.deviceStatistic,
  data_pageViews: data.pageViews,
  // 工位屏模板
  stationScreen_getList: stationScreen.getList,
  stationScreen_getOne: stationScreen.getOne,
  stationScreen_addOne: stationScreen.addOne,
  stationScreen_updateOne: stationScreen.updateOne,
  stationScreen_deleteList: stationScreen.deleteList,
  stationScreen_addNewOne: stationScreen.addNewOne,
  // 设备
  device_findByQuery: device.findByQuery,
  device_add: device.add,
  device_updateBySn: device.updateBySn,
  device_deleteBySn: device.deleteBySn,
  device_findAll: device.findAll,
  device_findDevices: device.findDevices,
  device_importDevice: device.importDevice,
  device_downloadFile: device.downloadFile,
  device_exportDevice: device.exportDevice,
  device_reset: device.reset,
  // 设备绑定/解绑操作日志
  deviceActions_findDeviceActions: deviceActions.findDeviceActions,
  device_findDevicelogs: device.findDevicelogs,
  device_updateMany: device.updateMany
}



// WEBPACK FOOTER //
// ./src/services/index.js